<template>
  <div :class="[$setClasses, boxShadow]">
    <div :class="$vClass('wrapper')">
      <slot></slot>
    </div>
  </div>
</template>

<script>

export default {
  name: 'WrapperNavbar',
  nameClassStyle: 'navbar',
  data() {
    return {
      navbarBackground: 'transparent',
      boxShadow: {
        'navbar--box-shadow': false,
      },
    };
  },
  methods: {
    scroll() {
      if (window.scrollY || document.documentElement.scrollTop || 0) {
        this.navbarBackground = 'var(--nxt-next-light-grey-blue)';
        this.boxShadow['navbar--box-shadow'] = true;
      } else {
        this.navbarBackground = 'transparent';
        this.boxShadow['navbar--box-shadow'] = false;
      }
    },
  },
  mounted() {
    window.addEventListener('scroll', this.scroll);
    window.addEventListener('resize', this.resize);
  },
  beforeUnmount() {
    window.removeEventListener('scroll', this.scroll);
    window.removeEventListener('resize', this.resize);
  },
};
</script>

<style lang="scss">
.layout {
  &.--booking, &.--mover {
    > .navbar {
      display: none;

      @include breakpoint(tablet) {
        display: flex;
      }
    }
  }
}

.navbar {
  border-bottom: solid 1px var(--nxt-color-light-grey);
  position: fixed;
  display: flex;
  z-index: 50;
  top: 0;
  left: 0;
  width: 100%;
  height: 60px;
  color: var(--nxt-color-white);

  &__wrapper {
    flex: 1 1 0%;
  }
  &--box-shadow {
    color: var(--nxt-color-primary);
    background-color: var(--nxt-color-light-grey);
    box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
  }

  &.--back {
    .navbar__wrapper {
      display: flex;
      align-items: center;
      text-overflow: ellipsis;
      overflow: hidden;

      > span {
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
        padding-right: var(--nxt-space-default);
        text-transform: uppercase;
      }
    }

    .el-button {
      background: transparent;
      box-shadow: none;
      color: inherit;
      text-transform: initial;
    }

    @include breakpoint(tablet) {
      position: inherit;
      border: none;
      z-index: 1;

      &.navbar--box-shadow {
        color: var(--nxt-color-white);
        background-color: transparent;
        box-shadow: none;
      }

      .el-button {
        padding-left: 0;
      }
    }
  }
}
</style>
